import './SequenceSidebar.scss';

import React from 'react';
import classNames from 'classnames';

const tableConfig = {
  preflop_hu_cash: {
    'BTN': {seat: 'top-center', dealer: true},
    'BB': {seat: 'bottom-center'},
  },
  preflop_6max_cash: {
    'SB': {seat: 'right-center'},
    'BB': {seat: 'bottom-right'},
    'UTG': {seat: 'bottom-left'},
    'HJ': {seat: 'left-center'},
    'CO': {seat: 'top-left'},
    'BTN': {seat: 'top-right', dealer: true},
  },
  preflop_8max_cash: {
    'SB': {seat: 'right-center'},
    'BB': {seat: 'bottom-right-end'},
    'UTG': {seat: 'bottom-center'},
    'UTG+1': {seat: 'bottom-left-end'},
    'LJ': {seat: 'left-center'},
    'HJ': {seat: 'top-left-end'},
    'CO': {seat: 'top-center'},
    'BTN': {seat: 'top-right-end', dealer: true},
  }
}


// PokerTable component
const PokerTable = ({data}) => {

  // Calculate pot
  let pot = 0;
  Object.entries(data).map(([position_name, position]) =>{
    if(position.bet) {
      pot += position.bet.amount;
    }
  });

  return (
    <div className="ptabl_container">
      <div className={"ptabl ptabl_horizontal"}>
        <div className={"ptabl_table"}>
          <div className={"ptabl_center"}>
            <div className={"popt_pot popt_ppt popt_ppt_visible"}>
              <div className={"popt_pot_value"}>
                {pot} BB
              </div>
            </div>
          </div>
          <div className={"ptabl_seats horizontal-seats"}>
            {Object.entries(data).map(([position_name, position], index) => (
              <div className={classNames("ptabl_seats_seat", position.seat)} key={index}>
                <div className={classNames("player test-circle-borders player_timetravel", position_name, {
                  player_folded: position.folded,
                  player_active: position.active,
                })}>
                  <div className="player_inner">
                    <div className="player_name">
                      <span className="player_name_position">{position_name}</span>
                    </div>
                    <span className="player_stack player_stack_invisible">{position.stack}</span>
                  </div>
                  {position.dealer && <div className="player_dealer-chip"></div>}
                  {position.bet &&
                    <div className="player_bet player_cards_empty player_bet_visible">
                      <div className="player_bet_inner">
                        <div className="pchips pchips_cont">
                          <div className="pchips_column anim-coin-column">
                            {position.bet.stack.map((amount, index) => (
                              <div className={classNames("pchips_coin anim-fade-in", `pchips_coin_${amount}`)}
                                   key={index}></div>
                            ))}
                          </div>
                        </div>
                        <div className="player_bet_money">{position.bet.amount}</div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const ChartActions = ({chartActions}) => {
  const actionNumber = Object.keys(chartActions).length;
  return (
    <div className={'sqm-actions-wrapper'} style={{
      '--sab-columns': `repeat(${actionNumber}, 1fr)`
    }}>
      {Object.entries(chartActions).map(([actionName, actionData], index) => (
        <div className={`sqm-actions--action color-${actionName}`} key={index}>
          <div className={"sqm-actions--action__name"}>{actionData.title}</div>
          <div className={"sqm-actions--action__bottom"}>
            <div className={"sqm-actions--action__value"}>{actionData.value}%</div>
            <div className={"sqm-actions--action__combos"}>
              {actionData.combos}
              <span>combos</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export const SequenceSidebar = ({seqData, chartData}) => {
  const data = tableConfig[seqData.chartType];

  Object.entries(data).forEach(([position_name]) => {
    switch (position_name) {
      case (seqData.chartType === 'preflop_hu_cash') ? 'BTN' : 'SB':
        data[position_name].bet = {
          amount: 0.5,
          stack: [5]
        };
        break;
      case 'BB':
        data[position_name].bet = {
          amount: 1,
          stack: [1]
        };
        break;
      default:
        data[position_name].stack = 0;
        data[position_name].active = false;
        data[position_name].folded = false;
        data[position_name].bet = null;
    }
  })

  const groupedActions = {};
  if(seqData.actions) {
    seqData.actions.forEach((key, index) => {
      console.log('key', key)
      const position_name = Object.keys(key)[0];
      groupedActions[index] = {[position_name]: key[position_name]};
    });
  }

  if (groupedActions) {
    Object.values(groupedActions).forEach((item) => {
      const position_name = Object.keys(item)[0];
      const type = item[position_name][0];
      const amount = parseInt(item[position_name].substring(1)) / 1000;

      if(seqData.chartType === 'preflop_hu_cash' && (
        position_name === 'UTG' || position_name === 'UTG+1' ||
        position_name === 'LJ' || position_name === 'HJ' ||
        position_name === 'CO'
      )) return;

      if(seqData.chartType === 'preflop_6max_cash' && position_name === 'UTG+1') return;

      switch (type) {
        case 'F':
          data[position_name].folded = true;
          break;
        case 'C':
        case 'R':
          data[position_name].bet = {
            amount: amount,
            stack: [10, 10, 10]
          };
          break;
      }
    });
  }

  if (seqData.position && data[seqData.position]) {
    Object.entries(data).forEach(([position_name]) => {
      data[position_name].active = false;
    });
    data[seqData.position].active = true;
  }

  if (!seqData) {
    return null;
  }
  const chartActions = chartData.chartActions;

  const sortedChartActions = {};
  if(chartActions) {
    const chartActionsKeys = Object.keys(chartActions);
    chartActionsKeys.sort((a, b) => {
      const order = ['allin', 'raise', 'call', 'fold'];
      return order.indexOf(a) - order.indexOf(b);
    });
    chartActionsKeys.forEach((key) => {
      sortedChartActions[key] = chartActions[key];
    });
  }

  if(!chartActions) return null;

  return (
    <div>
      <ChartActions chartActions={sortedChartActions}/>
      <div className={'sqm-table-wrapper'}>
        <div className={'poker-table'}>
          <PokerTable data={data}/>
        </div>
      </div>
    </div>
  );
}